/**
 * Default controller provided for popovers that don't need any custom logic in their controller but simply render
 * content or only need access to the close function or bound options.
 *
 * @export
 * @class PopoverDefaultController
 */
export default class PopoverDefaultController {
  constructor(close, options) {
    'ngInject'
    this.close = close
    this.options = options
  }
}
